{
  "CSAT": {
    "TITLE": "Bewerten Sie Ihre Konversation",
    "PLACEHOLDER": "Erzählen Sie uns mehr...",
    "RATINGS": {
      "POOR": "😞 Schlecht",
      "FAIR": "😑 Mäßig",
      "AVERAGE": "😐 Durchschnittlich",
      "GOOD": "😀 Gut",
      "EXCELLENT": "😍 Ausgezeichnet"
    }
  }
}
